export const toNumber = (value) => {
	const parsed = parseFloat(value)
	return Number.isFinite(parsed) ? parsed : 0
}

export const roundCurrency = (value) => Number(toNumber(value).toFixed(2))

const nearlyEqual = (first, second, tolerance = 0.03) => (
	Math.abs(toNumber(first) - toNumber(second)) <= tolerance
)

export const getQuantity = (item = {}) => {
	const cantidadProducto = toNumber(item.cantidad_producto)
	if (cantidadProducto > 0) return cantidadProducto

	const cantidad = toNumber(item.cantidad)
	return cantidad > 0 ? cantidad : 1
}

export const getDisplayUnitPrice = (item = {}) => {
	if (toNumber(item.precio_rebajado) > 0) return toNumber(item.precio_rebajado)
	if (toNumber(item.precio_producto_desc_user) > 0) return toNumber(item.precio_producto_desc_user)
	return toNumber(item.precio_producto)
}

export const calcularSubtotalLineas = (pedidos = []) => roundCurrency(
	(pedidos || []).reduce((acc, item) => acc + (getDisplayUnitPrice(item) * getQuantity(item)), 0)
)

export const getTaxValue = (datosPago = {}) => {
	const valorImpuesto = toNumber(datosPago.valor_impuesto)
	if (valorImpuesto > 0) return roundCurrency(valorImpuesto)

	const tax = toNumber(datosPago.tax)
	if (tax > 0) return roundCurrency(tax)

	return roundCurrency(datosPago.taxes)
}

export const obtenerTotalesPedido = (datosFactura = {}) => {
	const datosPago = datosFactura?.datosPago || {}
	const pedido = Array.isArray(datosFactura?.pedido) ? datosFactura.pedido : []
	const subtotalLineas = calcularSubtotalLineas(pedido)
	const subtotalGuardado = roundCurrency(datosPago.subtotal)
	const subtotalNetoGuardado = roundCurrency(
		datosPago.subtotalNeto ?? datosPago.subtotal_neto ?? datosPago.subtotalConDescuento
	)
	const esFacturacion = datosFactura?.canal === 'Facturación' || datosPago.canal === 'Facturación'
	const descuentoGuardado = roundCurrency(datosPago.descuento)
	const descuentoCalculado = subtotalLineas > 0 && subtotalGuardado > 0
		? roundCurrency(Math.max(0, subtotalLineas - subtotalGuardado))
		: 0
	const descuento = esFacturacion ? descuentoGuardado : descuentoCalculado
	const taxes = getTaxValue(datosPago)
	const total = roundCurrency(datosPago.total ?? datosFactura.total)

	let subtotalBruto = subtotalGuardado > 0 ? subtotalGuardado : subtotalLineas
	let subtotalNeto = subtotalNetoGuardado > 0
		? subtotalNetoGuardado
		: roundCurrency(Math.max(0, subtotalBruto - descuento))

	if (descuento > 0 && subtotalGuardado > 0 && subtotalNetoGuardado === 0) {
		const subtotalMasDescuento = roundCurrency(subtotalGuardado + descuento)
		const lineasConfirmanSubtotalNeto = subtotalLineas > 0 && nearlyEqual(subtotalLineas, subtotalMasDescuento)
		const totalConfirmaSubtotalNeto = total > 0 && nearlyEqual(total, subtotalGuardado + taxes)

		if (lineasConfirmanSubtotalNeto || totalConfirmaSubtotalNeto) {
			subtotalBruto = subtotalLineas > 0 ? subtotalLineas : subtotalMasDescuento
			subtotalNeto = subtotalGuardado
		}
	}

	return {
		subtotalBruto: roundCurrency(subtotalBruto),
		subtotalNeto: roundCurrency(subtotalNeto),
		descuento,
		taxes,
		total,
		subtotalLineas
	}
}

export const calcularEnvioFactura = (datosFactura = {}) => {
	const datosPago = datosFactura?.datosPago || {}
	const totalCargas = roundCurrency(datosPago.totalCargas)

	if (totalCargas > 0 && datosFactura?.canal !== 'Facturación') {
		return totalCargas
	}

	const { total, subtotalNeto, taxes } = obtenerTotalesPedido(datosFactura)
	return roundCurrency(Math.max(0, total - subtotalNeto - taxes))
}
